import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { TenantSettingsContext } from '../../context/TenantSettingsContext';
import { isProductEnabled } from './products';

// Redirects to the platform launchpad when the given product is disabled for
// this tenant. Waits for settings to load to avoid a flash-redirect.
const ProductGuard = ({ product, children }) => {
  const tenantSettings = useContext(TenantSettingsContext);
  if (!tenantSettings.isLoaded) return null;
  if (!isProductEnabled(product, tenantSettings)) return <Navigate to="/" replace />;
  return children;
};

ProductGuard.propTypes = {
  product: PropTypes.string.isRequired,
  children: PropTypes.node
};

export default ProductGuard;
